import React from "react";

import { component_tool } from "@/tool";
import moment from "moment/moment";
import { Cascader } from 'antd';
import {
  operateTypeEnum,
  operateBizTypeEnum,
  statusEnum,
  generateDict,
} from '../util'

let { WizModal } = component_tool

let componentName = 'userActionLogInfo';

const columns = (data) => {
  let { typeData } = data
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "会话标识",
      name: "linkTraceId",
      dataIndex: "linkTraceId",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "操作人",
      name: "fullName",
      dataIndex: "fullName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "操作类型",
      name: "operateType",
      dataIndex: "operateType",
      dict: generateDict(operateTypeEnum),
      searchItem: {
        type: 'select',
      },
      tableItem: {},
    },
    {
      title: "业务类型",
      name: "operateBizType",
      dataIndex: "operateBizType",
      searchItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return getFieldDecorator('operateBizType', {})(
            <Cascader
              options={typeData || []}
              placeholder="请输入业务类型" />
          )
        }
      },
      tableItem: {},
    },
    {
      title: "业务名称",
      name: "operateBizName",
      dataIndex: "operateBizName",
      searchItem: {},
      tableItem: {
        width: 400,
      },
    },
    {
      title: "请求状态",
      name: "status",
      dataIndex: "status",
      dict: generateDict(statusEnum),
      searchItem: {
        type: 'select',
      },
      tableItem: {},
    },
    {
      title: "请求时间",
      name: "createTime",
      dataIndex: "createTime",
      searchItem: {
        type: 'date~',
      },
      tableItem: {},
    },
  ]
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.operateBizType?.length == 2) {
              value.businessType = value.operateBizType[1]
            } else {
              value.businessType = ''
            }
            if (value.createTime && value.createTime.length === 2) {
              value.startDate = moment(value.createTime[0]).format('YYYY-MM-DD HH:mm:ss')
              value.endDate = moment(value.createTime[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            return value
          },
          collapse: false,
          cols: {
            xs: 24,
            md: 24,
            xl: 12
          },
          buttonSort: ['export', 'import'],
          buttons: [
            {
              key: "export",
              custom: true,
              params: {
                icon: 'export',
                type: 'export',
                children: '导出',
              },
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export"
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter };
                }
              }
            },
            {
              key: 'import',
              custom: true,
              params: { icon: 'import', children: '业务类型导入', type: 'import' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/userActionLogInfo/list/userActionEntityTypeImport',
                }
              }
            },
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
          pageSizeOptions: [
            '10', '20', '40', '60', '200'
          ],
        },
        rowOperateSort: ['look'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: { children: "查看" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/userActionLogInfoManager/look"
              },
            },
          },
        ],
        commonOperate: {},
      }
    }
  };
}

const apis = () => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    import: {
      path: `${componentName}/import`,
      payload: {
        key: `${componentName}@import`,
        apiParams: {}
      }
    },
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
